import { render, staticRenderFns } from "./InsuredInformation.vue?vue&type=template&id=6c6365e1&scoped=true&"
import script from "./InsuredInformation.vue?vue&type=script&lang=js&"
export * from "./InsuredInformation.vue?vue&type=script&lang=js&"
import style0 from "./InsuredInformation.vue?vue&type=style&index=0&id=6c6365e1&lang=scss&scoped=true&"
import style1 from "./InsuredInformation.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6365e1",
  null
  
)

export default component.exports